module.exports = __webpack_public_path__ + "media/img/aetb_410499-407ef8c9.jpg";